import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { X } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";
import { Button } from "@/components/ui/button";

const STORAGE_KEY = "pk_signup_popup_dismissed_v1";
const DELAY_MS = 8000;

export const SignupPopup = () => {
  const { user, loading } = useAuth();
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (pathname.startsWith("/wholesale") || pathname === "/auth") {
      setOpen(false);
      return;
    }
    if (loading || user) return;
    if (typeof window === "undefined") return;
    if (localStorage.getItem(STORAGE_KEY)) return;

    const timer = window.setTimeout(() => setOpen(true), DELAY_MS);
    return () => window.clearTimeout(timer);
  }, [pathname, user, loading]);

  const dismiss = () => {
    setOpen(false);
    try {
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch {
      // ignore
    }
  };

  if (!open || user) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="signup-popup-title"
      className="fixed inset-0 z-[100] flex items-center justify-center p-4 animate-in fade-in duration-300"
    >
      <button
        type="button"
        aria-label="Close signup popup"
        onClick={dismiss}
        className="absolute inset-0 bg-foreground/60 backdrop-blur-sm"
      />
      <div className="relative bg-background border border-border shadow-2xl rounded-lg max-w-md w-full p-8 md:p-10 text-center animate-in zoom-in-95 duration-300">
        <button
          type="button"
          onClick={dismiss}
          aria-label="Close"
          className="absolute top-3 right-3 p-2 text-muted-foreground hover:text-foreground transition-colors rounded-md"
        >
          <X className="h-4 w-4" />
        </button>

        <p className="text-gold font-medium tracking-[0.2em] uppercase text-xs mb-3">
          Join Param Kesar®
        </p>
        <h2
          id="signup-popup-title"
          className="font-display text-2xl md:text-3xl font-bold mb-3"
        >
          Save 20% on your first order
        </h2>
        <p className="text-muted-foreground text-sm md:text-base mb-6 leading-relaxed">
          Create an account for early access to seasonal harvests and exclusive
          subscriber pricing on every shipment.
        </p>
        <div className="flex flex-col gap-3">
          <Link to="/auth?mode=signup" onClick={dismiss}>
            <Button size="lg" className="w-full tracking-wide">
              Create your account
            </Button>
          </Link>
          <button
            type="button"
            onClick={dismiss}
            className="text-xs text-muted-foreground hover:text-foreground transition-colors"
          >
            No thanks, maybe later
          </button>
        </div>
      </div>
    </div>
  );
};
